import { oklchToRgba } from "@/document/model/color";
import type { SceneNode } from "@/document/model/nodes";
import type { Paint } from "@/document/model/styles";
import type { RenderClearColor } from "@/renderer/overlayTypes";

export function opaqueFrameFillClearColor(node: SceneNode | undefined): RenderClearColor | undefined {
  if (node?.type !== "frame") {
    return undefined;
  }

  return opaqueSolidPaintColor(node.style.fills.at(-1));
}

function opaqueSolidPaintColor(paint: Paint | undefined): RenderClearColor | undefined {
  if (paint?.type !== "solid") {
    return undefined;
  }

  const [r, g, b] = oklchToRgba(paint.color);
  return [r, g, b, 1];
}
